/** Modulo Ata (270) — contracts/enums.yaml */
export const ATA_ACAO = {
  VER: 2701,
  CRIAR_EDITAR: 2702,
  EXCLUIR: 2703,
  PUBLICAR: 2704,
} as const;

export const ATA_ACOES_MODULO = [
  ATA_ACAO.VER,
  ATA_ACAO.CRIAR_EDITAR,
  ATA_ACAO.EXCLUIR,
  ATA_ACAO.PUBLICAR,
] as const;
